import { SubmitHandler, UseFormSetError, FieldValues } from 'react-hook-form';

const createSubmitHandler =
  <T extends FieldValues>({
    onSubmit,
    onSuccess,
    setError,
  }: {
    onSubmit: SubmitHandler<T>;
    onSuccess?: () => void;
    setError: UseFormSetError<T>;
  }): SubmitHandler<T> =>
  async (data) => {
    try {
      await onSubmit(data);
      onSuccess?.();
    } catch (e) {
      if (e instanceof Error)
        return setError('root', {
          message: e.message,
        });

      return setError('root', {
        message: 'Something went wrong',
      });
    }
  };

export { createSubmitHandler };
